module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_03_6DE79_1SF_GAZ.09d7462b.png";